import React, { useMemo } from "react";
// import { Box, Paper, Typography, Stack } from "@mui/material";
import Flex from "../../../../../components/Flex";
import Text from "../../../../../components/Text";
import {
  CHART_COLORS,
  CHART_TYPOGRAPHY,
} from "../../../../../components/app/provider/patient/chart";
import { CLAIMS_STATUS_LIST } from "./claims-constants";

interface ClaimStatusCardsProps {
  counts: {
    [key: string]: number;
  };
  onCardClick?: (statusValue: string, index: number) => void;
  activeIndex?: number | null;
}

// type StatusType = "ACCEPTED" | "DRAFT" | "REJECTED" | "SUBMITTED" | "DENIED";

// const STATUS_COLORS: Record<StatusType, { text: string; background: string }> =
//   {
//     ACCEPTED: {
//       text: "#00B917",
//       background: "#E5F8E7",
//     },
//     DRAFT: {
//       text: "#FFAA00",
//       background: "#FFF4E4",
//     },
//     REJECTED: {
//       text: "#FF0000",
//       background: "#FFF4E4",
//     },
//     SUBMITTED: {
//       text: "#315095",
//       background: "#88C6E3",
//     },
//     DENIED: {
//       text: "#F17405",
//       background: "#E4DBD3",
//     },
//   };

type CountRecord = Record<string, number>;

const ClaimStatusCards: React.FC<ClaimStatusCardsProps> = ({
  counts,
  onCardClick,
  activeIndex,
}) => {
  const allCount = useMemo(() => {
    return Object.values(counts ?? {})?.reduce((acc, cur: any) => acc + cur, 0);
  }, [counts]);

  const CountData = { ...(counts as object), ALL: allCount } as CountRecord;

  return (
    // <Stack direction="row" spacing={3} width="100%" mb={3}>
    <Flex
      alignItems={"center"}
      justifyContent={"start"}
      gap={"10px"}
      sx={{
        backgroundColor: CHART_COLORS.surfaceColor,
        width: "100%",
        padding: "10px 12px",
      }}
    >
      <Text fontSize={CHART_TYPOGRAPHY.body5.fontSize}>Claim Types :</Text>
      {[{ label: "All", value: "ALL" }, ...CLAIMS_STATUS_LIST].map(
        (status, idx) => {
          const isActive = activeIndex === idx;
          const count = CountData[status.value] ?? 0;
          // const colors = STATUS_COLORS[status.value as StatusType];

          return (
            // <Paper
            //   key={status.value}
            //   elevation={0}
            //   sx={{
            //     flex: 1,
            //     bgcolor: colors.background,
            //     borderRadius: 2,
            //     boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
            //     p: 2,
            //     display: "flex",
            //     alignItems: "center",
            //     justifyContent: "space-between",
            //     minWidth: 180,
            //     height: 56,
            //     border: isActive ? `2px solid ${colors.text}` : "none",
            //     cursor: "pointer",
            //     transition: "background 0.2s, box-shadow 0.2s, border 0.2s",
            //     "&:hover": {
            //       boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            //     },
            //   }}
            //   onClick={() => onCardClick && onCardClick(status.value, idx)}
            // >
            //   <Typography
            //     variant="subtitle1"
            //     fontWeight={600}
            //     color={colors.text}
            //     sx={{
            //       fontSize: 15,
            //       lineHeight: 1.2,
            //       whiteSpace: "nowrap",
            //       overflow: "hidden",
            //       textOverflow: "ellipsis",
            //     }}
            //   >
            //     {status.label + " Claims"}
            //   </Typography>
            //   <Box
            //     sx={{
            //       bgcolor: "#FFFFFF",
            //       color: colors.text,
            //       borderRadius: 2,
            //       px: 2,
            //       py: 0.5,
            //       fontWeight: 700,
            //       fontSize: 18,
            //       minWidth: 32,
            //       textAlign: "center",
            //       display: "inline-block",
            //     }}
            //   >
            //     {count}
            //   </Box>
            // </Paper>
            <Flex
              sx={{
                cursor: "pointer",
                alignItems: "center",
                justifyContent: "center",
                height: "26px",
                borderRadius: "9999px",
                padding: "0 12px",
                backgroundColor: isActive
                  ? CHART_COLORS.badgeConfirmedBg
                  : CHART_COLORS.surfaceWhite,
                color: CHART_COLORS.primary,
                border: `1px solid ${CHART_COLORS.primary}`,
                ...CHART_TYPOGRAPHY.body5,
                fontWeight: CHART_TYPOGRAPHY.weight.regular,
                whiteSpace: "nowrap",
              }}
              onClick={() => onCardClick && onCardClick(status.value, idx)}
            >
              {status.label} ({count})
            </Flex>
          );
        }
      )}
    </Flex>
    // </Stack>
  );
};

export default ClaimStatusCards;
